import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Grid, Skeleton, Typography } from '@mui/material';
import { DivRootStyled, SearchInputStyled } from './CredentialsToolbar.styles';
import { TranslationKeys } from 'app/translations';

const CredentialsToolbar = props => {
  const { className, handleSearch, intl, totalCount } = props;

  return (
    <DivRootStyled className={className}>
      <Grid container spacing={3}>
        <Grid item xs={4}>
          <Typography variant="h5">
            <FormattedMessage id={TranslationKeys.menu_credentials} />
          </Typography>
          <Typography variant="subtitle2" textTransform={'uppercase'}>
            {typeof totalCount !== 'undefined' ? (
              <FormattedMessage id={TranslationKeys.credentials_totalCount} values={{ totalCount }} />
            ) : (
              <Skeleton width={200} />
            )}
          </Typography>
        </Grid>
        <Grid item xs={4}>
          <SearchInputStyled
            onChange={handleSearch}
            placeholder={intl.formatMessage({ id: TranslationKeys.credentials_search }).toUpperCase()}
          />
        </Grid>
      </Grid>
    </DivRootStyled>
  );
};

CredentialsToolbar.propTypes = {
  className: PropTypes.string,
  handleClickAdd: PropTypes.func.isRequired,
  handleSearch: PropTypes.func.isRequired,
  totalCount: PropTypes.number,
};

export default injectIntl(CredentialsToolbar);
